import styled from 'styled-components';


export const FloatingButton = styled.button`
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 50px;
  width: 75px;
  height: 75px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border-radius: 50%;
  transition: transform 0.3s ease-in;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.3);

  &:hover{
    transform: translateY(-5px); 
  }

`

export const NavbarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid transparent;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: translateY(0);
  padding: 0;

  &.scrolled {
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(15px);
    box-shadow: 0 8px 32px rgba(59, 130, 246, 0.12);
    border-bottom: 1px solid rgba(59, 130, 246, 0.2);
    transform: translateY(0) scale(1.02);
    animation: stickySlide 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &:not(.scrolled) {
    animation: resetSlide 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @keyframes stickySlide {
    0% {
      transform: translateY(-100%) scale(0.95);
      opacity: 0.8;
    }
    50% {
      transform: translateY(-10px) scale(1.05);
    }
    100% {
      transform: translateY(0) scale(1.02);
      opacity: 1;
    }
  }

  @keyframes resetSlide {
    0% {
      transform: translateY(0) scale(1.02);
      background: rgba(255, 255, 255, 0.98);
      backdrop-filter: blur(15px);
      box-shadow: 0 8px 32px rgba(59, 130, 246, 0.12);
      border-bottom: 1px solid rgba(59, 130, 246, 0.2);
    }
    100% {
      transform: translateY(0) scale(1);
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      box-shadow: none;
      border-bottom: 1px solid transparent;
    }
  }
`;

export const NavbarInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  height: 70px;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

export const NavbarBrand = styled.div`
  display: flex;
  align-items: center;
`;

export const BrandText = styled.span`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #3b82f6;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #2563eb;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const NavbarMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 870px) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(15px);
    flex-direction: column;
    gap: 0;
    padding: 1rem 0;
    border-top: 1px solid rgba(59, 130, 246, 0.1);
    box-shadow: 0 8px 32px rgba(59, 130, 246, 0.1);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;

    &.active {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const NavbarItem = styled.button`
  background: none;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  text-decoration: none;

  &:hover {
    color: #3b82f6;
    background: rgba(59, 130, 246, 0.05);
    transform: translateY(-1px);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    background: #3b82f6;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-50%);
  }

  &:hover::after {
    width: 80%;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 1rem 2rem;
    border-radius: 0;
    font-size: 1.1rem;

    &::after {
      display: none;
    }

    @media (max-width: 480px) {
      padding: 0.875rem 1.5rem;
      font-size: 1rem;
    }
  }
`;

export const ContactButton = styled(NavbarItem)`
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white !important;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);

  &:hover {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  }

  &::after {
    display: none;
  }

  @media (max-width: 768px) {
    margin: 1rem 2rem;
    width: calc(100% - 4rem);
    border-radius: 12px;
  }
`;

export const NavbarToggle = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  border-radius: 8px;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(59, 130, 246, 0.05);
  }

  @media (max-width: 870px) {
    display: flex;
  }
`;

export const HamburgerLine = styled.span`
  width: 24px;
  height: 2px;
  background: #374151;
  margin: 3px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;

  &.line-1-active {
    transform: rotate(45deg) translate(6px, 6px);
    background: #3b82f6;
  }

  &.line-2-active {
    opacity: 0;
  }

  &.line-3-active {
    transform: rotate(-45deg) translate(6px, -6px);
    background: #3b82f6;
  }
`;

export const GlobalNavbarStyles = styled.div`
  html {
    scroll-behavior: smooth;
  }

  body {
    padding-top: 70px;
  }
`;